// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-textarea-docs',
    templateUrl: './textarea.docs.generated.html',
})
export class UITextareaDocs { }
